module.exports = __webpack_public_path__ + "img/client-storebuy_en.15864339.svg";